<template>
  <section class="h-full bg-white">
    <div class="d-flex flex-column">
      <div class="t-center selectTitle">Select Product</div>
      <!-- <div class="flex-grow-1 h-full scroll-y t-left" @click="changeUrl()"> -->
      <div class="flex-grow-1 h-full t-left" @click="changeUrl()">
        <div class="imageDisplay">
          <img src="../images/STAR_app_campus_VD.png" />
        </div>
        <div class="brandName">Visual Display</div>
        <!-- <div class="more">MORE</div> -->
      </div>

      <!-- <div class="flex-grow-1 h-full scroll-y t-right" @click="changeUrlToDA()"> -->
      <div class="flex-grow-1 h-full t-right" @click="changeUrlToDA()">
        <div class="imageDisplay">
          <img src="../images/STAR_app_campus_DA.png" />
        </div>
        <div class="brandName2">Digital Appliances</div>
        <!-- <div class="more2">MORE</div> -->
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 브랜드 선택화면 컴포넌트(service select screen component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import brandApi from "@/api/brandApi.js";
import i18nApi from "@/api/i18nApi.js";
import { captureApiError } from "@/utils/sentryApiHandler.js"
import { setChannel, CHANNEL } from "@/utils/autoLoginUtil";

export default {
  name: "BrandSelect",
  data() {
    return {
      brandState: false,
      brands: [],
      brandCode: "",
      brandName: "",
      languages: "",
      language: "",
      submitState: false,
      selectedBrandCode: "",
      showSelectBtn: false,
      lastScrollPosition: 0,
      reload: 0,
    };
  },

  beforeRouteEnter(to, from, next) {
    i18nApi
      .guestBrands()
      .then((response) => {
        let responseBrands = response.data.data;
        console.log("responseBrands", responseBrands);
        next((vm) => {
          vm.brands = responseBrands;
        });
      })
      .catch((err) => {
        captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        next("/error");
      });
    if (to.name == "BrandSelect" && from.name == "setting") {
      location.reload();
    }
  },

  beforeCreate() {
    // throw new Error("Brand select Error Test");
    /*************************** Get token from React Native via webview ****************/
    console.log("token", this.$route.query.tokens);
    console.log("deviceOS", this.$route.query.deviceOS);
    if (this.$route.query.tokens) {
      localStorage.setItem("fbToken", this.$route.query.tokens);
    }
    if (this.$route.query.deviceOS) {
      localStorage.setItem("deviceOS", this.$route.query.deviceOS);
    }
  },

  beforeDestroy() {
    this.$hideLoading();
  },

  methods: {
    // 스크롤 d이벤트 이동(on scroll event)
    onScroll(event) {
      const currentScrollPosition = event.target.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      this.showSelectBtn = currentScrollPosition > this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },

    changeUrl(type) {
      this.$showLoading();
      this.selectedBrandCode = "samsung";
      // console.log("this.selectedBrandCode", this.selectedBrandCode);
      this.setBrand();

      // localStorage에 VD 저장
      setChannel(CHANNEL.VD);

      this.$router.push("Login");
    },

    changeUrlToDA() {
      console.log("HERE");

      // 로딩 표시
      this.$showLoading();

      // 로그인 페이지 주소 설정
      // - 로컬 개발 환경: localhost 기준
      // - 운영 환경: 환경 변수에서 도메인 가져옴
      let loginOrigin = location.host.indexOf("localhost") !== -1
        ? "http://localhost:8081/#/login"
        : process.env.VUE_APP_DA_HOST + "/#/login";

      // tokens 값을 라우터 쿼리에서 우선 가져오고, 없으면 localStorage에서 가져옴
      let tokens = (this.$route.query && this.$route.query.tokens) || localStorage.getItem("fbToken");

      // deviceOS도 동일하게 처리
      let deviceOS = (this.$route.query && this.$route.query.deviceOS) || localStorage.getItem("deviceOS");

      // 쿼리 파라미터 문자열을 쉽게 다루기 위해 URLSearchParams 사용
      let queryParams = new URLSearchParams();

      // tokens가 있으면 쿼리에 추가
      if (tokens) queryParams.append("tokens", tokens);

      // deviceOS가 있으면 쿼리에 추가
      if (deviceOS) queryParams.append("deviceOS", deviceOS);

      // 내부 링크임을 명시하는 파라미터 추가
      queryParams.set("linkType", "INTERNAL_LINK");

      // 채널 정보를 localStorage 등에 저장 (ex: "DA")
      setChannel(CHANNEL.DA);

      // 최종적으로 DA 로그인 페이지로 리디렉션
      // → tokens, deviceOS, linkType이 포함된 쿼리 스트링 붙여 이동
      window.location.href = loginOrigin + "?" + queryParams.toString();
    },

    // click brand select button
    setBrand() {
      // console.log("this.selectedBrandCode", this.selectedBrandCode);
      if (this.selectedBrandCode) {
        let findBrandInfo = _.find(this.brands, (brand) => {
          return brand.code === this.selectedBrandCode;
        });

        // console.log('findBrandInfo', findBrandInfo)
        // console.log('findBrandInfo', findBrandInfo)

        window.BRAND_CODE = findBrandInfo.code;
        window.BRAND_NAME = findBrandInfo.name;
        window.BRAND_LOGO = findBrandInfo.logo;
        window.BRAND_COMPANY = findBrandInfo.companyName;

        localStorage.setItem("brandCode", findBrandInfo.code);
        localStorage.setItem("brandName", findBrandInfo.name);
        localStorage.setItem("brandLogo", findBrandInfo.logo);
        localStorage.setItem("brandCompany", findBrandInfo.companyName);
        //var self =  this
        brandApi.brandManager().then((response) => {
          console.log("response", response);
          window.BRAND_MANAGER_NAME = response.data.data.name;
          window.BRAND_MANAGER_EMAIL = response.data.data.email;
          window.BRAND_MANAGER_PHONE = response.data.data.phone;
          this.$router.push("/login");
        }).catch((err) => {
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });
      } else {
        this.$snackOpen({
          contents: "Select Service",
          btnDisplayYN: true,
          btnDisplay: "OK",
        }).then(() => {});
      }
    },
  },
};
</script>

<style scoped>
/* .h-full .brand1 .imageDisplay {
  height: 200px;
  width: 360px;
} */

.selectTitle {
  margin: 13px 24px 14px 24px;
  font-size: 22px;
  font-weight: 450;
}

.brandName {
  margin: 10px 24px 10px 24px;
  font-size: 22px;
  font-weight: 500;
}
.more {
  margin: 5px 0px 24px 24px;
  text-decoration: underline;
}

.brandName2 {
  margin: 10px 24px 0px 24px;
  font-size: 22px;
  font-weight: 500;
}
.more2 {
  margin: 5px 24px 24px 0px;
  text-decoration: underline;
}

.h-full {
  min-height: 272px !important;
}

@media all and (max-width: 840px) {
  #sidebarContent {
    background-color: hsla(0, 0%, 0%, 0.7);
  }

  html[dir="ltr"] #outerContainer.sidebarOpen #viewerContainer {
    left: 0px !important;
  }
  html[dir="rtl"] #outerContainer.sidebarOpen #viewerContainer {
    right: 0px !important;
  }

  #outerContainer .hiddenLargeView,
  #outerContainer .hiddenMediumView {
    display: inherit;
  }
  #outerContainer .visibleLargeView,
  #outerContainer .visibleMediumView {
    display: none;
  }
}
</style>